const ZOOM = {
    buttons: document.querySelectorAll('.zoom__button'),
    onReady() {
        ZOOM.checkSettings();
        ZOOM.buttons.forEach(button => {
            button.addEventListener('click', () => {
                button.classList.contains('increase') && ZOOM.change({ zoom: 0.25, method: '+' });   
                button.classList.contains('decrease') && ZOOM.change({ zoom: 0.25, method: '-' });   
            }); 
        });
    },
    checkSettings() {
        let pages         = document.querySelectorAll('.page');
        let zoom          = COOKIE.get({name: 'zoom'});
        let zoomValueNode = document.getElementById('zoom-value');
        if (zoom !== '') {
            if (zoomValueNode === null) return;
            zoomValueNode.textContent = `${parseFloat(zoom) * 100}%`;
            pages.forEach(page => {
                page.style.zoom = zoom;
            });
        }
    },
    change({ zoom, method }) {
        let pages = document.querySelectorAll('.download');
        let temp  = pages[0].style.zoom !== '' ? parseFloat(pages[0].style.zoom) : parseFloat(getComputedStyle(pages[0]).zoom);
        let value = method === '+' ? temp + zoom : temp - zoom;
        if (value < 0.25 || value > 2.50) return;
        document.getElementById('zoom-value').textContent = `${value * 100}%`;
        pages.forEach(page => {
            page.style.zoom = value;
        });
        COOKIE.set({
            name: 'zoom',
            value: value,
            days: 365
        });
    }
}